
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    linkButtons: {
      type: Array,
      default: () => []
    },
    image: {
      type: String,
      default: require('@/assets/images/404-desktop.jpeg')
    }
  }
}
